import React from "react";
import classNames from "classnames/bind";
import OfferTokenizedContent from "components/OfferTokenizedContent/OfferTokenizedContent";
import PackageIcon from "components/PackageIcon/PackageIcon";
import { OfferTokenValues } from "types/api/exclusive_offers.d";
import { ComponentBackgroundColor } from "types/componentBackground";
import * as styles from "./OfferHighlightCard.module.scss";
import { OfferHighlight } from "./OfferHighlights";
const cx = classNames.bind(styles);

export interface OfferHighlightCardProps {
  offer: OfferHighlight;
  tokenValues: OfferTokenValues;
  backgroundColor: ComponentBackgroundColor;
}

const OfferHighlightCard: React.FC<OfferHighlightCardProps> = ({
  offer,
  tokenValues,
  backgroundColor
}) => {
  return (
    <div
      className={cx({
        offer: true,
        backgroundNeutral05: backgroundColor == "neutral05",
        backgroundWhite: backgroundColor == "white"
      })}
    >
      {offer.icon && <PackageIcon icon={offer.icon} />}
      <div className={styles.title}>
        <OfferTokenizedContent content={offer.name} tokenValues={tokenValues} />
      </div>
      <div className={styles.content}>
        <OfferTokenizedContent
          content={offer.description}
          tokenValues={tokenValues}
        />
      </div>
    </div>
  );
};

export default OfferHighlightCard;
